import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=51bf9316&scoped=true"
import script from "./OnBoarding.vue?vue&type=script&lang=ts"
export * from "./OnBoarding.vue?vue&type=script&lang=ts"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=51bf9316&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf9316",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51bf9316')) {
      api.createRecord('51bf9316', component.options)
    } else {
      api.reload('51bf9316', component.options)
    }
    module.hot.accept("./OnBoarding.vue?vue&type=template&id=51bf9316&scoped=true", function () {
      api.rerender('51bf9316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnBoarding.vue"
export default component.exports